import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { useAddOnsPage } from '../../../hooks/useAddOnPage';
import HubPlanPickerRow from './HubPlanPickerRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPlanPickerWrapper = styled.div.withConfig({
  displayName: "HubPlanPickerListContainer__StyledPlanPickerWrapper",
  componentId: "sc-1abgm1i-0"
})(["display:flex;flex-direction:column;flex:1;width:inherit;"]);
const HubPlanPickerListContainer = ({
  productLines
}) => {
  const {
    showAddonsPage
  } = useAddOnsPage();
  return /*#__PURE__*/_jsxs(StyledPlanPickerWrapper, {
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      children: showAddonsPage ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.selectProducts"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.selectProductsAndAddons"
      })
    }), productLines.map(productLine => /*#__PURE__*/_jsx(HubPlanPickerRow, {
      productLine: productLine
    }, productLine))]
  });
};
export default HubPlanPickerListContainer;